import { render, staticRenderFns } from "./contact-details.vue?vue&type=template&id=a26edc44&scoped=true"
import script from "./contact-details.vue?vue&type=script&lang=js"
export * from "./contact-details.vue?vue&type=script&lang=js"
import style0 from "./contact-details.vue?vue&type=style&index=0&id=a26edc44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26edc44",
  null
  
)

export default component.exports